/* =========================================================================
   KENZA MOBILE DRAWER v9
   - Page-stack navigation (root, shop, cursussen)
   - Accordion in Shop sub-page (+/− toggle, only one open at a time? no — multi)
   - Full event delegation
   ========================================================================= */
(function () {
  'use strict';

  let pageStack = ['root'];
  let initialized = false;

  function getDrawer() {
    return document.getElementById('Drawer-MobileNav');
  }
  function getBackdrop() {
    const drawer = getDrawer();
    if (!drawer) return null;
    let backdrop = drawer.previousElementSibling;
    if (backdrop && backdrop.classList.contains('kenza-drawer__backdrop')) {
      return backdrop;
    }
    backdrop = document.createElement('div');
    backdrop.className = 'kenza-drawer__backdrop';
    drawer.parentNode.insertBefore(backdrop, drawer);
    return backdrop;
  }
  function isOurDrawer(drawer) {
    return drawer && drawer.classList.contains('kenza-drawer');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;
    const backdrop = getBackdrop();
    drawer.removeAttribute('hidden');
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.classList.add('kenza-drawer-open');
    resetToRoot();
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;
    const backdrop = getBackdrop();
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('kenza-drawer-open');
    const hamburger = document.querySelector('.mobile-nav-toggle.kenza-hamburger button');
    if (hamburger) {
      try { hamburger.focus({ preventScroll: true }); } catch (_) {}
    }
  }

  function goToPage(pageId, title) {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;
    const targetPage = drawer.querySelector('[data-page="' + cssEscape(pageId) + '"]');
    if (!targetPage) return;

    const currentPageId = pageStack[pageStack.length - 1];
    const currentPage = drawer.querySelector('[data-page="' + cssEscape(currentPageId) + '"]');
    if (currentPage) {
      currentPage.classList.remove('is-active');
      currentPage.setAttribute('aria-hidden', 'true');
      if (currentPageId === 'root') {
        currentPage.classList.add('is-pushed');
      }
    }

    targetPage.classList.add('is-active');
    targetPage.removeAttribute('aria-hidden');
    pageStack.push(pageId);

    drawer.classList.add('is-on-subpage');
    const titleEl = drawer.querySelector('[data-drawer-page-title]');
    if (titleEl) {
      titleEl.textContent = title || targetPage.dataset.pageTitle || '';
    }

    // Reset accordion state on new page
    targetPage.querySelectorAll('.kenza-drawer__acc-item.is-open').forEach((el) => {
      el.classList.remove('is-open');
      const head = el.querySelector('[data-acc-toggle]');
      if (head) head.setAttribute('aria-expanded', 'false');
    });

    const body = targetPage.querySelector('.kenza-drawer__body');
    if (body) body.scrollTop = 0;
  }

  function goBack() {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;
    if (pageStack.length <= 1) return;

    const currentPageId = pageStack.pop();
    const currentPage = drawer.querySelector('[data-page="' + cssEscape(currentPageId) + '"]');
    if (currentPage) {
      currentPage.classList.remove('is-active');
      currentPage.setAttribute('aria-hidden', 'true');
    }

    const prevPageId = pageStack[pageStack.length - 1];
    const prevPage = drawer.querySelector('[data-page="' + cssEscape(prevPageId) + '"]');
    if (prevPage) {
      prevPage.classList.add('is-active');
      prevPage.removeAttribute('aria-hidden');
      if (prevPageId === 'root') {
        prevPage.classList.remove('is-pushed');
      }
    }

    if (prevPageId === 'root') {
      drawer.classList.remove('is-on-subpage');
      const titleEl = drawer.querySelector('[data-drawer-page-title]');
      if (titleEl) titleEl.textContent = '';
    } else {
      const titleEl = drawer.querySelector('[data-drawer-page-title]');
      if (titleEl) titleEl.textContent = prevPage ? (prevPage.dataset.pageTitle || '') : '';
    }
  }

  function resetToRoot() {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;
    drawer.querySelectorAll('.kenza-drawer__page').forEach((page) => {
      if (page.dataset.page === 'root') {
        page.classList.add('is-active');
        page.classList.remove('is-pushed');
        page.removeAttribute('aria-hidden');
      } else {
        page.classList.remove('is-active');
        page.setAttribute('aria-hidden', 'true');
      }
    });
    drawer.classList.remove('is-on-subpage');
    const titleEl = drawer.querySelector('[data-drawer-page-title]');
    if (titleEl) titleEl.textContent = '';
    // Close all accordion items
    drawer.querySelectorAll('.kenza-drawer__acc-item.is-open').forEach((el) => {
      el.classList.remove('is-open');
      const head = el.querySelector('[data-acc-toggle]');
      if (head) head.setAttribute('aria-expanded', 'false');
    });
    pageStack = ['root'];
  }

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function bindGlobalListeners() {
    if (initialized) return;
    initialized = true;
    document.addEventListener('click', handleClick, true);
    document.addEventListener('keydown', handleKey);

    let tsx = 0, tsy = 0, tactive = false;
    document.addEventListener('touchstart', (e) => {
      const drawer = getDrawer();
      if (!isOurDrawer(drawer) || !drawer.classList.contains('is-open')) return;
      if (drawer.classList.contains('is-on-subpage')) return;
      if (!drawer.contains(e.target)) return;
      tsx = e.touches[0].clientX;
      tsy = e.touches[0].clientY;
      tactive = true;
    }, { passive: true });
    document.addEventListener('touchend', (e) => {
      if (!tactive) return;
      tactive = false;
      const ex = e.changedTouches[0].clientX;
      const ey = e.changedTouches[0].clientY;
      if ((ex - tsx) < -80 && Math.abs(ey - tsy) < 60) closeDrawer();
    }, { passive: true });
  }

  function handleClick(e) {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer)) return;

    const opener = e.target.closest('[data-kenza-opener], drawer-opener[data-drawer="#Drawer-MobileNav"], .mobile-nav-toggle.kenza-hamburger');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      return;
    }

    const backdrop = e.target.closest('.kenza-drawer__backdrop');
    if (backdrop) { e.preventDefault(); closeDrawer(); return; }

    if (!drawer.contains(e.target)) return;

    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-drawer-back]')) { e.preventDefault(); goBack(); return; }

    const gotoBtn = e.target.closest('[data-drawer-goto]');
    if (gotoBtn) {
      e.preventDefault();
      e.stopPropagation();
      goToPage(gotoBtn.getAttribute('data-drawer-goto'), gotoBtn.getAttribute('data-drawer-goto-title'));
      return;
    }

    // Accordion toggle
    const accHead = e.target.closest('[data-acc-toggle]');
    if (accHead) {
      e.preventDefault();
      e.stopPropagation();
      const item = accHead.closest('.kenza-drawer__acc-item');
      if (!item) return;
      const wasOpen = item.classList.contains('is-open');
      if (wasOpen) {
        item.classList.remove('is-open');
        accHead.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        accHead.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const label = e.target.closest('a.kenza-drawer__label, a.kenza-drawer__cta, a.kenza-drawer__account, a.kenza-drawer__social-link');
    if (label && label.tagName === 'A') {
      const href = label.getAttribute('href');
      if (href && href !== '#' && href !== '') {
        closeDrawer();
      }
    }
  }

  function handleKey(e) {
    const drawer = getDrawer();
    if (!isOurDrawer(drawer) || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      if (drawer.classList.contains('is-on-subpage')) goBack();
      else closeDrawer();
    }
  }

  function boot() { bindGlobalListeners(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', () => { pageStack = ['root']; });
})();